import { render } from "./DiabeteSummary.vue?vue&type=template&id=79ace7ea"
import script from "./DiabeteSummary.vue?vue&type=script&lang=js"
export * from "./DiabeteSummary.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__